import React from 'react';
import PropTypes from 'prop-types';
import Accordion from '../../components/accordion';
import Hyperlink from '../../components/hyperlink';
import Wrapper from '../../components/wrapper';
import './styles.css';

/**
 * SubFooterNavigation
 */
const SubFooterNavigation = ({
                               containerId,
                               containerClass,
                               items,
                             }) => {
  return (
    <Wrapper
      containerId={containerId}
      containerClass={containerClass}
    >
      <div className="SubFooterNavigation">
        {(items !== null) ?
          <div className="SubFooterNavigation__container">
            <div className="SubFooterNavigation__layout">
              {items.map((item, index) => {
                return (
                  (item.links !== null && item.title !== null) ?
                    <div className="SubFooterNavigation__layout-item"
                         key={index}
                    >
                      <Accordion
                        pageName={item.title}
                        pcText={item.title}
                        mbText={item.title}
                        open={false}
                      >
                        <Linklist links={item.links}/>
                      </Accordion>
                    </div>
                    : null
                )
              })}
            </div>
          </div>
          : null}
      </div>
    </Wrapper>
  )
};
SubFooterNavigation.propTypes = {
  containerId: PropTypes.string,
  containerClass: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.shape({
      pageName: PropTypes.string,
      pcText: PropTypes.string,
      mbText: PropTypes.string,
      href: PropTypes.string,
      external: PropTypes.bool,
    })),
  })),
};
SubFooterNavigation.defaultProps = {
  containerId: null,
  containerClass: null,
  items: null,
};
export default SubFooterNavigation;

/**
 *  Linklist
 */
const Linklist = ({
                    links,
                  }) => {
  return (
    <ul className="SubFooterNavigation__list-ul">
      {links.map((link, index) => {
        return (
          <li key={index}>
            <Hyperlink href={link.href}
                       pageName={link.pageName}
                       pcText={link.pcText}
                       mbText={link.mbText}
                       external={link.external}
            />
          </li>
        )
      })}
    </ul>
  )
};



// WEBPACK FOOTER //
// ./src/containers/sub-footer-navigation/index.jsx